/*
    Form for updating information about a trip record, or to depart it

    The values don't need to be submitted, they will be automatically 
    sent to the DB 3 seconds after the user finishes making changes
*/

import React from "react";
import Media from "react-media";

import Constants from "../Constants";
import MainContext from "../MainContext";

import TimeInput from "../Components/TimeInput";

import DataItem from "../Components/DataItem";

import { getDelayReasons, departBus, updateTripStatus } from "../Requests/BusOpsRequests";

import { checkDepartTimeWithinLimit } from "../Scripts/Utilities";

//
// replace "BLANK" with ""
//
function showValue(val){
    return val === "BLANK" ? "" : val;
}

let runUpdate = null;

//
// time in ms between last change and when update method is triggered
//
const UPDATE_DELAY = 3000;

export default class BusOpsDetailsForm extends React.Component {

    static contextType = MainContext;

    state = {
        lane: "",
        time: "",
        delay: "",
        reasons: [],
        reasonSelected: "",
        comment: "",
        vehicleID: "",
        arrivals: "",
        gettingOff: "",
        boarding: "",
        leftBehind: "",
        onDeparture: 0,
        previousTime: "",
        departureUpdated: false
    }

    //
    // depart the trip
    //
    submit = () => {

        // test if the trip is 45 minutes or more early or late
        // if so, prompt the user to check if they intend to do this
        if(!checkDepartTimeWithinLimit(this.props.data)){
            return;
        }

        // if we have the update already scheduled, turn it off
        if(runUpdate){
            clearTimeout(runUpdate);
        }

        // do we want to close this entry?
        // hide it?

        const params = {...this.props.data, ...this.state};

        const request = () => departBus(params);

        const then = ({data}) => {

            console.log("DEPART DATA", data);

            if(data){
                // remove this entry?
                this.context.sendNotification(false, `Successfully Departed: ${this.props.data.Route} ${this.props.data.Header.trim()}`);
                this.props.refresh();
                /*
                else {
                    if(this.props.mode === "ALL"){
                        this.props.updateTrip(data, this.props.index);
                    }
                    else if(this.props.mode === "NOT-DEPARTED"){
                        this.props.removeTrip(this.props.index);
                    }
                }
                */

                this.props.onClose();
            }
            else{
                this.context.sendNotification(true, "Failure to Depart, please try again");
            }
        };

        this.context.runProcessing(request, then, "departBus");
    }

    //
    // call to the API to update the trip record
    //
    updateTrip = () => {
        
        const params = {...this.props.data, ...this.state};

        if(this.state.time === this.state.previousTime){
            params.time = "";
        }

        if(this.state.onDeparture === ""
            || this.state.onDeparture === null
        ) {
            params.onDeparture = "BLANK";
        }

        console.log("UPDATING THE TRIP", params);
        params.delay = params.delay ? params.delay * 60 : "";

        console.log("UPDATE TRIP MANUAL DELAY?", params);

        const request = () => updateTripStatus(params);
        const then = ({data}) => {
            console.log("UPDATE TRIP COMPLETED", data);

            if(data){
                this.props.updateTrip(data, this.props.index);

                // only run this on the Active page
                // OK, so how do I know what page I'm on?

                if(this.state.departureUpdated && this.props.mode === "NOT-DEPARTED"){
                    console.log("MARK DEPARTURE EXISTS?", this.props.markDepartureUpdated);
                    this.props.markDepartureUpdated();
                }
            }
            else{
                // do we want to send an error notification here?
                //this.context.sendNotification(true, "Failure to Update");
            }
        };
        this.context.runProcessing(request, then, "updateTripStatus");
    }

    //
    // calculate the count of departing passengers for this trip
    //
    getDepartureValue = () => {
        let arrival = parseInt(this.state.arrivals);
        let boarding = parseInt(this.state.boarding);
        let gettingOff = parseInt(this.state.gettingOff);

        if(isNaN(arrival) && isNaN(boarding) && isNaN(gettingOff)){
            return "";
        }

        arrival = isNaN(arrival) ? 0 : arrival;
        boarding = isNaN(boarding) ? 0 : boarding;
        gettingOff = isNaN(gettingOff) ? 0 : gettingOff;

        return arrival + boarding - gettingOff;
    }

    //
    // respond to input value being changed
    // after state is changed, be sure to get the correct departing passenger count,
    // and then set up a timeout for when to run the auto-update method
    //
    updateValue = (evt) => {
        const val = evt.target.value === "" ? "BLANK" : evt.target.value;

        console.log({targetval: evt.target.value, val});

        if(evt.target.name === "time"){
            this.setState({departureUpdated: true});
        }

        this.setState({[evt.target.name]:val}, () => {
            this.setState({onDeparture: this.getDepartureValue()}, () => {
                console.log("updated state");

                // if we have the update already scheduled, turn it off
                if(runUpdate){
                    clearTimeout(runUpdate);
                }
    
                runUpdate = setTimeout(() => {
                    this.updateTrip();
                    runUpdate = null;
                }, UPDATE_DELAY);
            })
        });
    }

    //
    // DEPRECATED
    //
    runStatusUpdateToDB = () => {

        // this one I want to explicitly run in the background
        
        const params = {...this.props.data, ...this.state};
        updateTripStatus(params);

        // what will we do afterwards?
        // maybe mark something on the screen to indicate being up to date?
    }

    //
    //
    parseCount = (count) => {
        return count ? parseInt(count) : "";
    }

    //
    // set the default state based on data passed in from the trips records
    //
    componentDidMount() {

        console.log("DETAILS PROPS", this.props, this.parseCount(this.props.passArrival));

        const propData = this.props.data;

        const departure = propData.actual_departure_time
                            ? propData.actual_departure_time
                            : propData.SchedDepTime;

        const departureDate = new Date(departure);

        const minutes = departureDate.getMinutes();

        const time = departureDate.getHours() + ":" + ((minutes < 10) ? "0" + minutes : minutes);

        this.setState({
            time,
            lane: propData.ManualLaneGate || propData.SchedLaneGate, 
            vehicleID: propData.vehicle_id,
            arrivals: this.parseCount(propData.passArrival),
            gettingOff: this.parseCount(propData.passGetOff),
            boarding: this.parseCount(propData.passBoarding),
            leftBehind: this.parseCount(propData.passLeftBehind),
            delay: propData.ManualDelay ? propData.ManualDelay/60 : "",
            reasonSelected: propData.DelayReason,
            comment: propData.DelayComment,
            previousTime: time
        }, () => {
            this.setState({onDeparture: this.getDepartureValue()});
        });

        // get the list of delay reasons
        const request = () => getDelayReasons();
        const then = ({data}) => {
            console.log("DEPARTURE DELAY REASONS", data, this.context);

            const copy = [];
            const isBus = this.context.user.groupid === "BUS";

            data.forEach(d => {
                console.log("DELAY REASPON FILTER", d, d.Mode === "BUS", isBus);
                if(d.Mode === "BUS" && isBus){
                    copy.push(d);
                }
                else if (d.Mode !== "BUS" && !isBus){
                    copy.push(d);
                }
            });

            console.log("DELAY REASONS COPY", isBus, copy);

            this.setState({reasons: [{Reason: "Select a Reason", ReasonCode: ""}, ...copy]});
        };
        this.context.runProcessing(request, then, "getDelayReasons");
    }

    //
    //
    displayDelayReasons(){
        console.log("DELAY REASONS", this.state.reasons);

        return (
            <select name="reasonSelected" value={this.state.reasonSelected} onChange={this.updateValue}>
            {
                this.state.reasons.map((reason, index) => {
                    return <option key={index} value={reason.ReasonCode}>{reason.Reason}</option>
                })
            }
            </select>
        );
    }

    render() {

        const {data} = this.props;

        const isOperator = this.context.user.access === Constants.access.operator;

        const delayVal = data.ManualDelay || data.SecLate;
        const realtimeDelay = `${delayVal >= 0 ? "+": ""}${Math.round(delayVal/60)}M `;

        const cancelledOrNoShow = data.DelayReason === "NoShow" || data.DelayReason === "Cancelled";
        
        const vehicleIDColor = data.vehicleIDColor || "black";

        return (
            <div className="vertical">
                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <Media query="(max-width: 811px)">
                        <>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            margin: "0 16px"
                        }}>
                            <div className="form-element-horizontal">
                                <label>Route</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <><div>({data.switched.tripFrom.route})</div>&nbsp;</>
                                        : null
                                    }
                                    <DataItem val={data.Route} />
                                </div>
                            </div>
                            <div className="form-element-horizontal">
                                <label>Run</label>
                                <DataItem val={data.Run} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns:"1fr 3fr"}}>
                                <label>Dest</label>
                                <DataItem val={data.Header} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "2fr 3fr"}}>
                                <label>Scheduled<br />Departure</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <div>({data.switched.tripFrom.departure})</div>
                                        : null
                                    }
                                    <DataItem val={data.SchedDepTime} />
                                </div>
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "3fr 1fr"}}>
                                <label>Realtime Delay</label>
                                <DataItem val={realtimeDelay} color={data.delaycolor} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Lane</label>
                                <input className="short-input" type="text" name="lane" value={showValue(data.SchedLaneGate)} onChange={this.updateValue} />
                            </div>
                        </div>
                        </>
                    </Media>
                    <Media query="(min-width: 812px)">
                        <>
                        <div className="departure-form-subvertical">
                            <div className="form-element-horizontal">
                                <label>Route</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <><div>({data.switched.tripFrom.route})</div>&nbsp;</>
                                        : null
                                    }
                                    <DataItem val={data.Route} />
                                </div>
                            </div>
                            <div className="form-element-horizontal">
                                <label>Run</label>
                                <DataItem val={data.Run} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "1fr 6fr"}}>
                                <label>Dest</label>
                                <DataItem val={data.Header} />
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "2fr 5fr"}}>
                                <label>Scheduled<br />Departure</label>
                                <div className="swap-vertical">
                                    {
                                        data.switched && data.switched.tripFrom
                                        ? <div>({data.switched.tripFrom.departure})</div>
                                        : null
                                    }
                                    <DataItem val={data.SchedDepTime} />
                                </div>
                            </div>
                            <div className="form-element-horizontal" style={{gridTemplateColumns: "3fr 1fr"}}>
                                <label>Realtime<br />Delay</label>
                                <DataItem val={realtimeDelay} color={data.delaycolor} />
                            </div>
                        </div>
                        </>
                    </Media>
                </div>

                <div className="busops-form">    
                    <div style={{
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Media query="(max-width: 811px)">
                            <>
                            <div className="form-element-horizontal">
                                <label>Departed Time</label>
                                <TimeInput name="time" value={this.state.time} onChange={this.updateValue} nonMilitary={true} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Manual Delay</label>
                                <input className="short-input" type="number" name="delay" value={showValue(this.state.delay)} onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Delay Reason</label>
                                {this.displayDelayReasons()}
                            </div>
                            <div className="form-element-horizontal">
                                <label>Delay Location/Comment</label>
                                <textarea name="comment" rows="4" value={showValue(this.state.comment)} onChange={this.updateValue}>
                                </textarea>
                            </div>
        
                            <div className="form-element-horizontal">
                                <label>Vehicle ID#</label>
                                <input className="short-input" type="text" name="vehicleID" value={showValue(this.state.vehicleID)} onChange={this.updateValue} color={`var(--${vehicleIDColor.toLowerCase()})`} />
                            </div>
                            </>
                        </Media>
                        <Media query="(min-width: 812px)">
                            <>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                                <div className="form-element-horizontal">
                                    <label>Lane</label>
                                    <input className="short-input" type="text" name="lane" value={showValue(this.state.lane)} onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Vehicle ID#</label>
                                    <input className="short-input" type="text" name="vehicleID" value={showValue(this.state.vehicleID)} onChange={this.updateValue} color={`var(--${vehicleIDColor.toLowerCase()})`} />
                                </div>

                                <div className="form-element-horizontal">
                                    <label>Departed Time</label>
                                    <TimeInput name="time" value={showValue(this.state.time)} onChange={this.updateValue} nonMilitary={true} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Manual Delay</label>
                                    <input className="short-input" type="number" name="delay" value={showValue(this.state.delay)} onChange={this.updateValue} />
                                </div>
                            </div>

                            <div className="form-element-horizontal">
                                <label>Delay Reason</label>
                                {this.displayDelayReasons()}
                            </div>
                            <div className="form-element-horizontal">
                                <label>Delay Location/Comment</label>
                                <textarea name="comment" rows="4" value={showValue(this.state.comment)} onChange={this.updateValue}>
                                </textarea>
                            </div>
    
                            </>
                        </Media>
                    </div>
    
                    <div>
                        <div className="form-element-header">PASSENGER COUNTS</div>
                        <Media query="(max-width: 811px)">
                            <div style={{
                                display:"grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                                <div className="form-element-horizontal">
                                    <label>@ Arrival</label>
                                    <input className="short-input" type="number" pattern="\d*" name="arrivals" value={showValue(this.state.arrivals)} onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Getting Off</label>
                                    <input className="short-input" type="number" pattern="\d*" name="gettingOff" value={showValue(this.state.gettingOff)} onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Boarding</label>
                                    <input className="short-input" type="number" pattern="\d*" name="boarding" value={showValue(this.state.boarding)} onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Left Behind</label>
                                    <input className="short-input" type="number" pattern="\d*" name="leftBehind" value={showValue(this.state.leftBehind)} onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>On Departure</label>
                                    <DataItem val={this.state.onDeparture} />
                                </div>
                            </div>
                        </Media>
                        <Media query="(min-width: 812px)">
                            <>
                            <div className="form-element-horizontal">
                                <label>@ Arrival</label>
                                <input className="short-input" type="number" pattern="\d*" name="arrivals" value={showValue(this.state.arrivals)} onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Getting Off</label>
                                <input className="short-input" type="number" pattern="\d*" name="gettingOff" value={showValue(this.state.gettingOff)} onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Boarding</label>
                                <input className="short-input" type="number" pattern="\d*" name="boarding" value={showValue(this.state.boarding)} onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Left Behind</label>
                                <input className="short-input" type="number" pattern="\d*" name="leftBehind" value={showValue(this.state.leftBehind)} onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>On Departure</label>
                                <DataItem val={this.state.onDeparture} />
                            </div>
                            </>
                        </Media>
                    </div>
    
                </div>
                {
                    // do we show the depart button or not
                    data.actual_departure_time === "" 
                    && !isOperator
                    && !cancelledOrNoShow
                    && (
                        <div className="option  " onClick={this.submit}>Depart</div>
                    )
                }
            </div>
        )
    }
}